import React, { ReactNode } from 'react';

import styles from './styles.module.scss';

export function LineChartTitle({ title }: { title: ReactNode }) {
  return typeof title === 'string' ? (
    <h4 className={styles.title}>{title}</h4>
  ) : (
    <>{title}</>
  );
}
